var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadioPoint10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-144.000000, -240.000000)",
    id: "Size_option_16px"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(141.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Radio_button_16",
    transform: "translate(0.000000, 89.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "active",
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "inner_oval",
    cx: 8,
    cy: 8,
    r: 5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioPoint10);
export default __webpack_public_path__ + "72df3dfd3717fbd65135d120599b4237.svg";
export { ForwardRef as ReactComponent };